import YoutubeEmbed from './YoutubeEmbed.vue'

export default YoutubeEmbed
